export const DATA_CURRENCY = [
  { value: "HKD", label: "HKD" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
  { value: "GBP", label: "GBP" },
  { value: "RMB", label: "RMB" },
  { value: "AUD", label: "AUD" },
  { value: "CAD", label: "CAD" },
  { value: "JPY", label: "JPY" },
  { value: "CHF", label: "CHF" },
  { value: "SGD", label: "SGD" },
];

export const DATA_GI_CHARGE_ITEMS = [
  "Premium",
  "IA Levy",
  "EC Levy",
  "MIB Levy",
  "Discount",
];

export const DATA_INCENTIVE_TYPE = [
  {
    value: "INCENTIVE",
    label: "INCENTIVE",
  },
  {
    value: "CHARGE",
    label: "CHARGE",
  },
];

export const DATA_BANK_TRANSACTION_TYPE = [
  {
    value: "WITHDRAWAL",
    label: "Withdrawal",
  },
  {
    value: "DEPOSIT",
    label: "Deposit",
  },
];

export const DATA_RENEWAL_REJECTION_REASON = [
  { value: "by_provider", label: "By Provider" },
  { value: "by_client", label: "By Client" },
  { value: "other", label: "Others" },
];

export const DATA_AML_RISK_LEVEL = [
  { value: "Unacceptable Risk", label: "Unacceptable Risk" },
  { value: "Increased Risk", label: "Increased Risk" },
  { value: "Standard Risk", label: "Standard Risk" },
  { value: "Low Risk", label: "Low Risk" },
  { value: "Exempted Risk", label: "Exempted Risk" },
];

export const DATA_RPQ_RISK_LEVEL = [
  { value: 1, label: "1 - Preservation 保本" },
  { value: 2, label: "2 - Conservative 穩健" },
  { value: 3, label: "3 - Balanced 均衡" },
  { value: 4, label: "4 - Growth 增長" },
  { value: 5, label: "5 - Aggressive 進取" },
];

export const DATA_PRODUCT_DEFAULT_CHECKLIST = [
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "642548fb59f8091d30f4cacc",
    name: "Client Service Agreement with FNA",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "642548fb59f8091d30f4cacd",
    name: "Client Service Agreement with MPF",
  },
  {
    optional: false,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af1",
    name: "Client's Identity (ID / Passport )",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af2",
    name: "Client Address Proof (within 3 months)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af3",

    name: "Client Service Agreement (ILAS)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af4",
    name: "Frontier Risk Profile Questionnaire (ILAS)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af5",
    name: "AML Assessment Form (CDD) ",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af6",
    name: "Enhanced Due Diligence Form (EDD)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af7",
    name: "Application Form",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af8",
    name: "Proposal ",
  },
  {
    optional: false,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8af9",
    name: "FNA",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8afa",
    name: "Provider Risk Profile Questionnaire (ILAS)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8afb",
    name: "Import Facts statement and applicant's declarations (ILAS)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8afc",
    name: "Import Facts statement and applicant's declarations (Premium Financing)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8afd",
    name: "Import Facts statement and applicant's declarations (MCV)",
  },
  {
    optional: false,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8afe",
    name: "Direct Debit Authorization (DDA)",
  },
  {
    optional: false,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8aff",
    name: "Initial Payment  (Credit Card/ Bank Slip/ Cheque/ Online Payment)",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8b00",
    name: "Supplementary Documents",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8b03",
    name: "External Transfer Form",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8b02",
    name: "Medical Report",
  },
  {
    optional: true,
    frontier: true,
    provider: true,
    _id: "6453504375b1112af17b8b01",
    name: "Others:",
  },
];

export const DATA_NUMBER_COMPARISON = [
  { value: "=", label: "= (Equal)" },
  { value: "<>", label: "<> (Between)" },
  { value: ">", label: "> (Larger)" },
  { value: ">=", label: ">= (Larger or Equal)" },
  { value: "<", label: "< (Smaller)" },
  { value: "<=", label: "<= (Smaller or Equal)" },
];

export const DATA_CALENDAR_EVENT_TYPE = [
  { value: "companyEvent", label: "Company Event" },
  { value: "inTraining", label: "Internal Training" },
  { value: "meeting", label: "Meeting" },
  { value: "vacation", label: "Vacation" },
  { value: "others", label: "Others" },
];

export const DATA_ROUND_ON = [
  { value: "RATE", label: "Rate" },
  { value: "MONEY", label: "Money" },
];

export const DATA_ADDRESS_TYPE = [
  { value: "residental", label: "Residental" },
  { value: "correspondence", label: "Correspondence" },
  { value: "registeredOffice", label: "Office" },
  { value: "contract", label: "Contract" },
  { value: "other", label: "Other" },
];

export const DATA_PHONE_TYPE = [
  { value: "work", label: "Work" },
  { value: "home", label: "Home Phone" },
  { value: "mobile", label: "Mobile" },
  { value: "fax", label: "Fax" },
  { value: "emergency", label: "Emergency" },
  { value: "other", label: "Other" },
];

export const DATA_EMAIL_TYPE = [
  { value: "work", label: "Work" },
  { value: "personal", label: "Personal" },
  { value: "billing", label: "Billing" },
  { value: "other", label: "Other" },
];

export const DATA_JURISDICTION = [
  { value: "Hong Kong", label: "Hong Kong 香港" },
  { value: "Macau", label: "Macau 澳門" },
  { value: "Singapore", label: "Singapore 新加坡" },
  { value: "Bermuda", label: "Bermuda 百慕達" },
];

export const DATA_PRODUCT_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "ACTIVE", label: "Active 可用" },
  { value: "INACTIVE", label: "InActive 停用" },
  { value: "HIDDEN", label: "Hidden 隐蔽" },
];

export const DATA_PRODUCT_AGETYPES = [
  { value: "PREVIOUS", label: "Previous Birthday" },
  { value: "NEXT", label: "Next Birthday" },

  { value: "NEAREST", label: "Nearest Birthday" },
];

export const DATA_RELATIONSHIP = [
  { value: "Same Person", label: "Same Person", group: "Other" },

  //Spouse
  { value: "Spouse", label: "Spouse", group: "Spouse" },
  { value: "Husband", label: "Husband", group: "Spouse" },
  { value: "Wife", label: "Wife", group: "Spouse" },

  //Parent
  { value: "Parent", label: "Parent", group: "Parent" },
  { value: "Father", label: "Father", group: "Parent" },
  { value: "Mother", label: "Mother", group: "Parent" },
  { value: "Legal Guardian", label: "Legal Guardian", group: "Parent" },

  //Sibling
  { value: "Brother", label: "Brother", group: "Sibling" },
  { value: "Sister", label: "Sister", group: "Sibling" },

  //Child
  { value: "Child", label: "Child", group: "Child" },
  { value: "Son", label: "Son", group: "Child" },
  { value: "Daughter", label: "Daughter", group: "Child" },

  // Extended family
  { value: "Grandparent", label: "Grandparent", group: "Extended" },
  { value: "Grandfather", label: "Grandfather", group: "Extended" },
  { value: "Grandson", label: "Grandson", group: "Extended" },
  { value: "Granddaughter", label: "Granddaughter", group: "Extended" },
  { value: "Uncle", label: "Uncle", group: "Extended" },
  { value: "Aunt", label: "Aunt", group: "Extended" },
  { value: "Cousin", label: "Cousin", group: "Extended" },
  { value: "Nephew", label: "Nephew", group: "Extended" },
  { value: "Niece", label: "Niece", group: "Extended" },
  // Other
  { value: "Trustee", label: "Trustee", group: "Other" },
  { value: "Employee", label: "Employee", group: "Other" },
  { value: "Partner", label: "Partner", group: "Other" },
  { value: "Friend", label: "Friend", group: "Other" },
  { value: "Other", label: "Other", group: "Other" },
];

export const DATA_RELATIONSHIP_CORPORATE = [
  // Ownership relationships
  { value: "Parent Company", label: "Parent Company", group: "Ownership" },
  { value: "Subsidiary", label: "Subsidiary", group: "Ownership" },
  { value: "Holding Company", label: "Holding Company", group: "Ownership" },
  {
    value: "Wholly-Owned Subsidiary",
    label: "Wholly-Owned Subsidiary",
    group: "Ownership",
  },

  // Sibling relationships
  { value: "Sister Company", label: "Sister Company", group: "Sibling" },
  {
    value: "Affiliated Company",
    label: "Affiliated Company",
    group: "Sibling",
  },
  { value: "Related Entity", label: "Related Entity", group: "Sibling" },

  // Partnership
  {
    value: "Joint Venture Partner",
    label: "Joint Venture Partner",
    group: "Partnership",
  },
  {
    value: "Strategic Partner",
    label: "Strategic Partner",
    group: "Partnership",
  },
  {
    value: "Business Partner",
    label: "Business Partner",
    group: "Partnership",
  },

  // Branch/Office
  { value: "Branch Office", label: "Branch Office", group: "Branch" },
  { value: "Regional Office", label: "Regional Office", group: "Branch" },
  {
    value: "Representative Office",
    label: "Representative Office",
    group: "Branch",
  },
  { value: "Headquarters", label: "Headquarters", group: "Branch" },

  // Other
  { value: "Shareholder", label: "Shareholder", group: "Other" },
  { value: "Investor", label: "Investor", group: "Other" },
  { value: "Supplier", label: "Supplier", group: "Other" },
  { value: "Customer", label: "Customer", group: "Other" },
  { value: "Vendor", label: "Vendor", group: "Other" },
  { value: "Other", label: "Other", group: "Other" },
];

export const DATA_OVERRIDING_LEVEL_TYPE = [
  { value: "upper", label: "Up Line 上線" },
  { value: "userGroup", label: "User Group 小組" },
  { value: "user", label: "User 指定用戶" },
];

export const DATA_BANK_ACCOUNT_TYPE = [
  { value: "CHECKING", label: "Checking 支票戶口" },
  { value: "SAVINGS", label: "Savings 儲蓄戶口" },
  { value: "CREDIT", label: "Credit 信用卡戶口" },
  { value: "LOAN", label: "Loan 貸款戶口" },
  { value: "INVESTMENT", label: "Investment 投資戶口" },
  { value: "OTHER", label: "Other 其他" },
];

export const DATA_MARIAGE_STATUS = [
  { value: "Single", label: "Single 单身 " },
  { value: "Married", label: "Married 已婚 " },
  { value: "Divorced", label: "Divorced 离婚 " },
  { value: "Widowed", label: "Widowed 丧偶 " },
  { value: "Undetermined", label: "Undetermined 未确定 " },
];
export const DATA_BANK_WITH_CODE = [
  {
    value: "003",
    label: "[ 003 ] Standard Chartered Hong Kong 渣打銀行(香港)",
  },
  {
    value: "004",
    label: "[ 004 ] Hongkong and Shanghai Banking Corporation 香港上海滙豐銀行",
  },
  {
    value: "009",
    label: "[ 009 ] China Construction Bank (Asia) 中國建設銀行(亞洲)",
  },
  { value: "012", label: "[ 012 ] Bank of China (Hong Kong) 中國銀行(香港)" },
  { value: "015", label: "[ 015 ] Bank of East Asia 東亞銀行" },
  { value: "016", label: "[ 016 ] DBS Bank (Hong Kong) 星展銀行(香港)" },
  {
    value: "018",
    label: "[ 018 ] China CITIC Bank International 中信銀行國際",
  },
  { value: "020", label: "[ 020 ] CMB Wing Lung Bank 招商永隆銀行" },
  { value: "024", label: "[ 024 ] Hang Seng Bank 恒生銀行" },
  { value: "025", label: "[ 025 ] Shanghai Commercial Bank 上海商業銀行" },
  {
    value: "382",
    label: "[ 382 ] Bank of Communications (Hong Kong) 交通銀行(香港)",
  },
  { value: "028", label: "[ 028 ] Public Bank (Hong Kong) 大眾銀行(香港)" },
  { value: "035", label: "[ 035 ] OCBC Wing Hang Bank 華僑永亨銀行" },
  { value: "038", label: "[ 038 ] Tai Yau Bank 大有銀行" },
  { value: "039", label: "[ 039 ] Chiyu Banking Corporation 集友銀行" },
  { value: "040", label: "[ 040 ] Dah Sing Bank 大新銀行" },
  { value: "041", label: "[ 041 ] Chong Hing Bank 創興銀行" },
  { value: "043", label: "[ 043 ] Nanyang Commercial Bank 南洋商業銀行" },
  { value: "061", label: "[ 061 ] Tai Sang Bank 大生銀行" },
  {
    value: "072",
    label:
      "[ 072 ] Industrial and Commercial Bank of China (Asia) 中國工商銀行(亞洲)",
  },
  { value: "128", label: "[ 128 ] Fubon Bank (Hong Kong) 富邦銀行(香港)" },
  { value: "250", label: "[ 250 ] Citibank (Hong Kong) Limited" },
  { value: "385", label: "[ 385 ] PING AN BANK CO., LTD." },
  { value: "387", label: "[ 387 ] ZA BANK LIMITED" },
  { value: "388", label: "[ 388 ] LIVI VB LIMITED" },
  { value: "389", label: "[ 389 ] MOX BANK LIMITED" },
  { value: "390", label: "[ 390 ] WELAB BANK LIMITED" },
  { value: "391", label: "[ 391 ] FUSION BANK LIMITED" },
  {
    value: "392",
    label: "[ 392 ] PING AN ONECONNECT BANK (HONG KONG) LIMITED",
  },
  { value: "393", label: "[ 393 ] ANT BANK (HONG KONG) LIMITED" },
  { value: "395", label: "[ 395 ] AIRSTAR BANK LIMITED" },
  { value: "238", label: "[ 238 ] China Merchants Bank 招商銀行" },
  {
    value: "239",
    label: " [ 239 ] TAIPEI FUBON COMMERCIAL BANK CO., LTD 台北富邦商業銀行",
  },
  {
    value: "206",
    label: "[ 206 ] CHANG HWA COMMERCIAL BANK 彰化商業銀行",
  },
  {
    value: "353",
    label: "[ 353 ] CHINA MINSHENG BANKING CORP 中國民生銀行",
  },

  {
    value: "236",
    label: "[ 236 ] CATHAY UNITED BANK 國泰世華商業銀行",
  },
  {
    value: "CUC",
    label: "[ CUC ] The Currency Cloud Limited",
  },
];

export const DATA_ID_TYPE = [
  { value: "HKID", label: "HK ID 香港身份證" },
  { value: "CNID", label: "Mainland China ID 大陸身份證" },
  {
    value: "Travel Permit",
    label: "China to HK Travel Permit 通行証",
  },
  { value: "MID No.", label: "Macau ID 澳門身份證" },
  { value: "BR No.", label: "BR No. 商業登記證" },
  { value: "CI No.", label: "CI No. 公司註冊證書" },
  { value: "Passport", label: "Passport 護照" },
  { value: "Other", label: "Other 其他" },
];

export const DATA_REPORT_DATE_TYPE = [
  { value: "submissionDate", label: "Submit Date" },
  { value: "createdAt", label: "Create Date" },
  { value: "signedDate", label: "Sign Date" },
  { value: "policyIssueDate", label: "Policy Issue Date" },
  { value: "policyCommenceDate", label: "Policy Commence Date" },
  { value: "payment.preliminaryDate", label: "Preliminary Date" },
];

export const DATA_GENDERS = [
  { value: "Male", label: "Male 男性 " },
  { value: "Female", label: "Female 女性 " },
];

export const DATA_AGE_TYPES = [
  { value: "PREVIOUS", label: "Previous Birthday 前一个生日 " },
  { value: "NEXT", label: "Next Birthday 下一个生日 " },
  { value: "NEAREST", label: "Nearest Birthday 最近的生日 " },
];

export const DATA_CLIENT_TYPES = [
  { label: "Individual 個人", value: "INDIVIDUAL" },
  { label: "Corporate 公司", value: "CORPORATE" },
  { label: "Staff 員工", value: "STAFF" },
  { label: "Consultant 經紀", value: "CONSULTANT" },
];

export const DATA_CLIENT_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "PENDING", label: "Pending" },
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "PROSPECT", label: "Prospect" },
  { value: "DORMANT", label: "Dormant" },
  { value: "SUSPENDED", label: "Suspended" },
];

export const DATA_RPQ_STATUS = [
  { value: "NONE", label: "None" },
  { value: "VALID", label: "Valid" },
  { value: "EXPIRED", label: "Expired" },
  { value: "EXPIRING_1W", label: "Expiring (1 week)" },
  { value: "EXPIRING_1M", label: "Expiring (1 month)" },
];

export const DATA_RANK_BY = [
  { label: "Case 訂單數量", shortName: "CASE", value: "BY_CASE" },
  { label: "First Year Premium 首年保費", shortName: "FYP", value: "BY_FYP" },
  {
    label: "First Year Commission (Consultant) 首年顧問佣金",
    shortName: "FYC",
    value: "BY_FYCC",
  },
];

export const DATA_LANGUAGE = [
  {
    value: "CANTONESE",
    label: "Cantonese 粵語 ",
  },
  {
    value: "MANDARINE",
    label: "Mandarine 普通話 ",
  },
  {
    value: "ENGLISH",
    label: "English 英語 ",
  },
  {
    value: "JAPANESE",
    label: "Japanese 日語 ",
  },
  {
    value: "FRENCH",
    label: "French 法語 ",
  },
  {
    value: "Other",
    label: "Other 其他 ",
  },
];

export const DATA_PAY_MODES = [
  { value: "MONTHLY", label: "Monthly" },
  { value: "QUARTERLY", label: "Quarterly" },
  { value: "SEMIANNUALLY", label: "Semi Annually" },
  { value: "ANNUALLY", label: "Annually" },
  { value: "LUMPSUM", label: "Lump Sum" },
];

export const DATA_PAY_STATUS = [
  { value: "ACTIVE", label: "Active 有效" },
  { value: "INACTIVE", label: "Inactive 停繳" },
  { value: "HOLIDAY", label: "Holiday 保費假期" },
  { value: "PENDING", label: "Pending 待處理" },
  { value: "SINGLE_PREMIUM", label: "Single Premium 躉繳" },
  { value: "PAID_UP", label: "Paid Up 繳清" },
];
export const DATA_ALLOWANCE_PAY_MODES = [
  { value: "WEEKLY", label: "Weekly" },
  { value: "MONTHLY", label: "Monthly" },
  { value: "QUARTERLY", label: "Quarterly" },
  { value: "ANNUALLY", label: "Annually" },
];

export const DATA_USER_TYPES = [
  { value: "BACKOFFICE", label: "Back Office" },
  { value: "CONSULTANT", label: "Consultant" },
  { value: "CHANNEL", label: "Channel" },
];

export const DATA_USER_CATEGORY = [
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "CORPORATE", label: "Corporate" },
];

export const DATA_USER_DISPOSAL_STATUS = [
  { value: "NONE", label: "None" },
  { value: "DISPOSAL", label: "Disposal" },
  { value: "DISPOSED", label: "Disposed" },
];

export const DATA_COUNTRY = [
  { value: "Afghanistan", label: "Afghanistan 阿富汗" },
  { value: "Albania", label: "Albania 阿爾巴尼亞" },
  { value: "Algeria", label: "Algeria 阿爾及利亞" },
  { value: "Andorra", label: "Andorra 安道爾" },
  { value: "Angola", label: "Angola 安哥拉" },
  { value: "Argentina", label: "Argentina 阿根廷" },
  { value: "Armenia", label: "Armenia 亞美尼亞" },
  { value: "Australia", label: "Australia 澳大利亞" },
  { value: "Austria", label: "Austria 奧地利" },
  { value: "Azerbaijan", label: "Azerbaijan 亞塞拜然" },
  { value: "Bahamas", label: "Bahamas 巴哈馬" },
  { value: "Bahrain", label: "Bahrain 巴林" },
  { value: "Bangladesh", label: "Bangladesh 孟加拉" },
  { value: "Barbados", label: "Barbados 巴巴多斯" },
  { value: "Belarus", label: "Belarus 白俄羅斯" },
  { value: "Belgium", label: "Belgium 比利時" },
  { value: "Belize", label: "Belize 伯利茲" },
  { value: "Benin", label: "Benin 貝南" },
  { value: "Bhutan", label: "Bhutan 不丹" },
  { value: "Bolivia", label: "Bolivia 玻利維亞" },

  { value: "Botswana", label: "Botswana 博茨瓦納" },
  { value: "Brazil", label: "Brazil 巴西" },
  { value: "Brunei", label: "Brunei 文萊" },
  { value: "Bulgaria", label: "Bulgaria 保加利亞" },
  { value: "Burkina Faso", label: "Burkina Faso 布吉納法索" },
  { value: "Burundi", label: "Burundi 布隆迪" },
  { value: "Cambodia", label: "Cambodia 柬埔寨" },
  { value: "Cameroon", label: "Cameroon 喀麥隆" },
  { value: "Canada", label: "Canada 加拿大" },
  { value: "Cape Verde", label: "Cape Verde 維德角" },
  { value: "Cayman Islands", label: "Cayman Islands 開曼群島" },
  {
    value: "Central African Republic",
    label: "Central African Republic 中非共和國",
  },
  { value: "Chad", label: "Chad 乍得" },
  { value: "Chile", label: "Chile 智利" },
  { value: "China", label: "China 中國" },
  { value: "Colombia", label: "Colombia 哥倫比亞" },
  { value: "Comoros", label: "Comoros 科摩羅" },
  { value: "Congo", label: "Congo 剛果" },
  { value: "Costa Rica", label: "Costa Rica 哥斯大黎加" },
  { value: "Croatia", label: "Croatia 克羅地亞" },
  { value: "Cuba", label: "Cuba 古巴" },
  { value: "Cyprus", label: "Cyprus 賽普勒斯" },
  { value: "Czech Republic", label: "Czech Republic 捷克" },
  { value: "Denmark", label: "Denmark 丹麥" },
  { value: "Djibouti", label: "Djibouti 吉布地" },
  { value: "Dominica", label: "Dominica 多米尼克" },
  { value: "Dominican Republic", label: "Dominican Republic 多明尼加共和國" },
  { value: "Ecuador", label: "Ecuador 厄瓜多爾" },
  { value: "Egypt", label: "Egypt 埃及" },
  { value: "El Salvador", label: "El Salvador 薩爾瓦多" },
  { value: "Estonia", label: "Estonia 愛沙尼亞" },
  { value: "Ethiopia", label: "Ethiopia 衣索比亞" },
  { value: "Finland", label: "Finland 芬蘭" },
  { value: "France", label: "France 法國" },
  { value: "Georgia", label: "Georgia 喬治亞" },
  { value: "Germany", label: "Germany 德國" },
  { value: "Ghana", label: "Ghana 迦納" },
  { value: "Greece", label: "Greece 希臘" },
  { value: "Greenland", label: "Greenland 格陵蘭" },
  { value: "Guatemala", label: "Guatemala 瓜地馬拉" },
  { value: "Hong Kong", label: "Hong Kong 香港" },
  { value: "Hungary", label: "Hungary 匈牙利" },
  { value: "Iceland", label: "Iceland 冰島" },
  { value: "India", label: "India 印度" },
  { value: "Indonesia", label: "Indonesia 印度尼西亞" },
  { value: "Iran", label: "Iran 伊朗" },
  { value: "Iraq", label: "Iraq 伊拉克" },
  { value: "Ireland", label: "Ireland 愛爾蘭" },
  { value: "Israel", label: "Israel 以色列" },
  { value: "Italy", label: "Italy 意大利" },
  { value: "Jamaica", label: "Jamaica 牙買加" },
  { value: "Japan", label: "Japan 日本" },
  { value: "Jordan", label: "Jordan 約旦" },
  { value: "Kazakhstan", label: "Kazakhstan 哈薩克" },
  { value: "Kenya", label: "Kenya 肯雅" },
  { value: "Kuwait", label: "Kuwait 科威特" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan 吉爾吉斯" },
  { value: "Laos", label: "Laos 寮國" },
  { value: "Latvia", label: "Latvia 拉脫維亞" },
  { value: "Lebanon", label: "Lebanon 黎巴嫩" },
  { value: "Libya", label: "Libya 利比亞" },
  { value: "Liechtenstein", label: "Liechtenstein 列支敦士登" },
  { value: "Lithuania", label: "Lithuania 立陶宛" },
  { value: "Luxembourg", label: "Luxembourg 盧森堡" },
  { value: "Macau", label: "Macau 澳門" },
  { value: "Madagascar", label: "Madagascar 馬達加斯加" },
  { value: "Malaysia", label: "Malaysia 馬來西亞" },
  { value: "Maldives", label: "Maldives 馬爾地夫" },
  { value: "Malta", label: "Malta 馬耳他" },
  { value: "Mexico", label: "Mexico 墨西哥" },
  { value: "Monaco", label: "Monaco 摩納哥" },
  { value: "Mongolia", label: "Mongolia 蒙古" },
  { value: "Morocco", label: "Morocco 摩洛哥" },
  { value: "Myanmar", label: "Myanmar 緬甸" },
  { value: "Nepal", label: "Nepal 尼泊爾" },
  { value: "Netherlands", label: "Netherlands 荷蘭" },
  { value: "New Zealand", label: "New Zealand 紐西蘭" },
  { value: "Nigeria", label: "Nigeria 奈及利亞" },
  { value: "Norway", label: "Norway 挪威" },
  { value: "Oman", label: "Oman 阿曼" },
  { value: "Pakistan", label: "Pakistan 巴基斯坦" },
  { value: "Panama", label: "Panama 巴拿馬" },
  { value: "Paraguay", label: "Paraguay 巴拉圭" },
  { value: "Peru", label: "Peru 秘魯" },
  { value: "Philippines", label: "Philippines 菲律賓" },
  { value: "Poland", label: "Poland 波蘭" },
  { value: "Portugal", label: "Portugal 葡萄牙" },
  { value: "Qatar", label: "Qatar 卡達" },
  { value: "Romania", label: "Romania 羅馬尼亞" },
  { value: "Russia", label: "Russia 俄羅斯" },
  { value: "Saudi Arabia", label: "Saudi Arabia 沙烏地阿拉伯" },
  { value: "Serbia", label: "Serbia 塞爾維亞" },
  { value: "Singapore", label: "Singapore 新加坡" },
  { value: "Slovakia", label: "Slovakia 斯洛伐克" },
  { value: "Slovenia", label: "Slovenia 斯洛維尼亞" },
  { value: "South Africa", label: "South Africa 南非" },
  { value: "South Korea", label: "South Korea 南韓" },
  { value: "Spain", label: "Spain 西班牙" },
  { value: "Sri Lanka", label: "Sri Lanka 斯里蘭卡" },
  { value: "Sweden", label: "Sweden 瑞典" },
  { value: "Switzerland", label: "Switzerland 瑞士" },
  { value: "Syria", label: "Syria 敘利亞" },
  { value: "Taiwan", label: "Taiwan 台灣" },
  { value: "Tajikistan", label: "Tajikistan 塔吉克" },
  { value: "Thailand", label: "Thailand 泰國" },
  { value: "Tunisia", label: "Tunisia 突尼西亞" },
  { value: "Turkey", label: "Turkey 土耳其" },
  { value: "Ukraine", label: "Ukraine 烏克蘭" },
  {
    value: "United Arab Emirates",
    label: "United Arab Emirates 阿拉伯聯合大公國",
  },
  { value: "United Kingdom", label: "United Kingdom 英國" },
  { value: "United States", label: "United States 美國" },
  { value: "Uruguay", label: "Uruguay 烏拉圭" },
  { value: "Uzbekistan", label: "Uzbekistan 烏茲別克" },
  { value: "Vatican City", label: "Vatican City 梵蒂岡" },
  { value: "Venezuela", label: "Venezuela 委內瑞拉" },
  { value: "Vietnam", label: "Vietnam 越南" },
  { value: "Yemen", label: "Yemen 葉門" },
  { value: "Zambia", label: "Zambia 尚比亞" },
  { value: "Zimbabwe", label: "Zimbabwe 辛巴威" },
  { value: "Other", label: "Other 其他" },
];

export const DATA_SALUATATION = [
  {
    value: "Mr.",
    label: "Mr. 先生 ",
  },
  {
    value: "Ms.",
    label: "Ms. 女士 ",
  },
  {
    value: "Mrs.",
    label: "Mrs. 夫人 ",
  },
  {
    value: "Corporate",
    label: "Corporate 公司",
  },
  {
    value: "Other",
    label: "Other 其他",
  },
  {
    value: "",
    label: "-- ",
  },
];

export const DATA_NATIONALITY = [
  {
    value: "Afghan",
    label: "Afghan 阿富汗籍 ",
  },
  {
    value: "Albanian",
    label: "Albanian 阿爾巴尼亞籍",
  },
  {
    value: "Algerian",
    label: "Algerian 阿爾及利亞籍",
  },
  {
    value: "American Samoan",
    label: "American Samoan 美屬薩摩亞籍",
  },
  {
    value: "Andorran",
    label: "Andorran 安道爾籍",
  },
  {
    value: "Angolan",
    label: "Angolan 安哥拉籍",
  },
  {
    value: "Argentinian",
    label: "Argentinian 阿根廷籍",
  },
  {
    value: "Armenian",
    label: "Armenian 亞美尼亞籍",
  },
  {
    value: "Australian",
    label: "Australian 澳洲籍 ",
  },
  {
    value: "Austrian",
    label: "Austrian 奧地利籍",
  },
  {
    value: "Azerbaijani",
    label: "Azerbaijani 阿塞拜疆籍",
  },
  {
    value: "Bahamian",
    label: "Bahamian 巴哈馬籍",
  },
  {
    value: "Bahraini",
    label: "Bahraini 巴林籍",
  },
  {
    value: "Bangladeshi",
    label: "Bangladeshi 孟加拉籍",
  },
  {
    value: "Barbadian",
    label: "Barbadian 巴巴多斯籍",
  },
  {
    value: "Belarusian",
    label: "Belarusian 白俄羅斯籍",
  },
  {
    value: "Belgian",
    label: "Belgian 比利時籍 ",
  },
  {
    value: "Belizean",
    label: "Belizean 伯利茲籍",
  },
  {
    value: "Beninese",
    label: "Beninese 貝寧籍",
  },
  {
    value: "Bhutanese",
    label: "Bhutanese 不丹籍",
  },
  {
    value: "Bolivian",
    label: "Bolivian 玻利維亞籍",
  },
  {
    value: "Bosnian",
    label: "Bosnian 波斯尼亞籍",
  },
  {
    value: "Botswanan",
    label: "Botswanan 博茨瓦納籍",
  },
  {
    value: "Brazilian",
    label: "Brazilian 巴西籍 ",
  },
  {
    value: "British",
    label: "British 英國籍 ",
  },
  {
    value: "Bruneian",
    label: "Bruneian 汶萊籍",
  },
  {
    value: "Bulgarian",
    label: "Bulgarian 保加利亞籍",
  },
  {
    value: "Burkinabe",
    label: "Burkinabe 布基納法索籍",
  },
  {
    value: "Burundian",
    label: "Burundian 布隆迪籍",
  },
  {
    value: "Cambodian",
    label: "Cambodian 柬埔寨籍",
  },
  {
    value: "Cameroonian",
    label: "Cameroonian 喀麥隆籍",
  },
  {
    value: "Canadian",
    label: "Canadian 加拿大籍 ",
  },
  {
    value: "Cape Verdean",
    label: "Cape Verdean 佛得角籍",
  },
  {
    value: "Central African",
    label: "Central African 中非籍",
  },
  {
    value: "Chadian",
    label: "Chadian 乍得籍",
  },
  {
    value: "Chilean",
    label: "Chilean 智利籍",
  },
  {
    value: "Chinese",
    label: "Chinese 中國籍 ",
  },
  {
    value: "Colombian",
    label: "Colombian 哥倫比亞籍",
  },
  {
    value: "Comoran",
    label: "Comoran 科摩羅籍",
  },
  {
    value: "Congolese",
    label: "Congolese 剛果籍",
  },
  {
    value: "Costa Rican",
    label: "Costa Rican 哥斯達黎加籍",
  },
  {
    value: "Croatian",
    label: "Croatian 克羅地亞籍",
  },
  {
    value: "Cuban",
    label: "Cuban 古巴籍",
  },
  {
    value: "Cypriot",
    label: "Cypriot 塞浦路斯籍",
  },
  {
    value: "Czech",
    label: "Czech 捷克籍",
  },
  {
    value: "Danish",
    label: "Danish 丹麥籍",
  },
  {
    value: "Djiboutian",
    label: "Djiboutian 吉布提籍",
  },
  {
    value: "Dominican",
    label: "Dominican 多米尼加籍",
  },
  {
    value: "Dutch",
    label: "Dutch 荷蘭籍 ",
  },
  {
    value: "East Timorese",
    label: "East Timorese 東帝汶籍",
  },
  {
    value: "Ecuadorian",
    label: "Ecuadorian 厄瓜多爾籍",
  },
  {
    value: "Egyptian",
    label: "Egyptian 埃及籍",
  },
  {
    value: "Emirati",
    label: "Emirati 阿聯酋籍",
  },
  {
    value: "Equatorial Guinean",
    label: "Equatorial Guinean 赤道幾內亞籍",
  },
  {
    value: "Eritrean",
    label: "Eritrean 厄立特里亞籍",
  },
  {
    value: "Estonian",
    label: "Estonian 愛沙尼亞籍",
  },
  {
    value: "Ethiopian",
    label: "Ethiopian 埃塞俄比亞籍",
  },
  {
    value: "Fijian",
    label: "Fijian 斐濟籍",
  },
  {
    value: "Filipino",
    label: "Filipino 菲律賓籍 ",
  },
  {
    value: "Finnish",
    label: "Finnish 芬蘭籍",
  },
  {
    value: "French",
    label: "French 法國籍 ",
  },
  {
    value: "Gabonese",
    label: "Gabonese 加蓬籍",
  },
  {
    value: "Gambian",
    label: "Gambian 岡比亞籍",
  },
  {
    value: "Georgian",
    label: "Georgian 格魯吉亞籍",
  },
  {
    value: "German",
    label: "German 德國籍 ",
  },
  {
    value: "Ghanaian",
    label: "Ghanaian 加納籍",
  },
  {
    value: "Greek",
    label: "Greek 希臘籍 ",
  },
  {
    value: "Grenadian",
    label: "Grenadian 格林納達籍",
  },
  {
    value: "Guatemalan",
    label: "Guatemalan 危地馬拉籍",
  },
  {
    value: "Guinean",
    label: "Guinean 幾內亞籍",
  },
  {
    value: "Guyanese",
    label: "Guyanese 圭亞那籍",
  },
  {
    value: "Haitian",
    label: "Haitian 海地籍",
  },
  {
    value: "Honduran",
    label: "Honduran 洪都拉斯籍",
  },
  {
    value: "Hungarian",
    label: "Hungarian 匈牙利籍",
  },
  {
    value: "Icelandic",
    label: "Icelandic 冰島籍",
  },
  {
    value: "Indian",
    label: "Indian 印度籍 ",
  },
  {
    value: "Indonesian",
    label: "Indonesian 印尼籍 ",
  },
  {
    value: "Iranian",
    label: "Iranian 伊朗籍",
  },
  {
    value: "Iraqi",
    label: "Iraqi 伊拉克籍",
  },
  {
    value: "Irish",
    label: "Irish 愛爾蘭籍 ",
  },
  {
    value: "Israeli",
    label: "Israeli 以色列籍",
  },
  {
    value: "Italian",
    label: "Italian 意大利籍 ",
  },
  {
    value: "Ivorian",
    label: "Ivorian 科特迪瓦籍",
  },
  {
    value: "Jamaican",
    label: "Jamaican 牙買加籍",
  },
  {
    value: "Japanese",
    label: "Japanese 日本籍 ",
  },
  {
    value: "Jordanian",
    label: "Jordanian 約旦籍",
  },
  {
    value: "Kazakhstani",
    label: "Kazakhstani 哈薩克籍",
  },
  {
    value: "Kenyan",
    label: "Kenyan 肯尼亞籍",
  },
  {
    value: "Kiribati",
    label: "Kiribati 基里巴斯籍",
  },
  {
    value: "Kuwaiti",
    label: "Kuwaiti 科威特籍",
  },
  {
    value: "Kyrgyz",
    label: "Kyrgyz 吉爾吉斯籍",
  },
  {
    value: "Laotian",
    label: "Laotian 老撾籍",
  },
  {
    value: "Latvian",
    label: "Latvian 拉脫維亞籍",
  },
  {
    value: "Lebanese",
    label: "Lebanese 黎巴嫩籍",
  },
  {
    value: "Lesotho",
    label: "Lesotho 萊索托籍",
  },
  {
    value: "Liberian",
    label: "Liberian 利比里亞籍",
  },
  {
    value: "Libyan",
    label: "Libyan 利比亞籍",
  },
  {
    value: "Liechtensteiner",
    label: "Liechtensteiner 列支敦士登籍",
  },
  {
    value: "Lithuanian",
    label: "Lithuanian 立陶宛籍",
  },
  {
    value: "Luxembourgish",
    label: "Luxembourgish 盧森堡籍",
  },
  {
    value: "Macedonian",
    label: "Macedonian 馬其頓籍",
  },
  {
    value: "Malagasy",
    label: "Malagasy 馬達加斯加籍",
  },
  {
    value: "Malawian",
    label: "Malawian 馬拉維籍",
  },
  {
    value: "Malaysian",
    label: "Malaysian 馬來西亞籍 ",
  },
  {
    value: "Maldivian",
    label: "Maldivian 馬爾代夫籍",
  },
  {
    value: "Malian",
    label: "Malian 馬里籍",
  },
  {
    value: "Maltese",
    label: "Maltese 馬耳他籍",
  },
  {
    value: "Marshallese",
    label: "Marshallese 馬紹爾籍",
  },
  {
    value: "Mauritanian",
    label: "Mauritanian 毛里塔尼亞籍",
  },
  {
    value: "Mauritian",
    label: "Mauritian 毛里求斯籍",
  },
  {
    value: "Mexican",
    label: "Mexican 墨西哥籍 ",
  },
  {
    value: "Micronesian",
    label: "Micronesian 密克羅尼西亞籍",
  },
  {
    value: "Moldovan",
    label: "Moldovan 摩爾多瓦籍",
  },
  {
    value: "Monacan",
    label: "Monacan 摩納哥籍",
  },
  {
    value: "Mongolian",
    label: "Mongolian 蒙古籍",
  },
  {
    value: "Montenegrin",
    label: "Montenegrin 黑山籍",
  },
  {
    value: "Moroccan",
    label: "Moroccan 摩洛哥籍",
  },
  {
    value: "Mozambican",
    label: "Mozambican 莫桑比克籍",
  },
  {
    value: "Myanmar",
    label: "Myanmar 緬甸籍",
  },
  {
    value: "Namibian",
    label: "Namibian 納米比亞籍",
  },
  {
    value: "Nauruan",
    label: "Nauruan 瑙魯籍",
  },
  {
    value: "Nepalese",
    label: "Nepalese 尼泊爾籍",
  },
  {
    value: "New Zealander",
    label: "New Zealander 紐西蘭籍 ",
  },
  {
    value: "Nicaraguan",
    label: "Nicaraguan 尼加拉瓜籍",
  },
  {
    value: "Nigerian",
    label: "Nigerian 尼日利亞籍",
  },
  {
    value: "Nigerien",
    label: "Nigerien 尼日爾籍",
  },
  {
    value: "North Korean",
    label: "North Korean 北韓籍",
  },
  {
    value: "Norwegian",
    label: "Norwegian 挪威籍 ",
  },
  {
    value: "Omani",
    label: "Omani 阿曼籍",
  },
  {
    value: "Pakistani",
    label: "Pakistani 巴基斯坦籍 ",
  },
  {
    value: "Palauan",
    label: "Palauan 帕勞籍",
  },
  {
    value: "Palestinian",
    label: "Palestinian 巴勒斯坦籍",
  },
  {
    value: "Panamanian",
    label: "Panamanian 巴拿馬籍",
  },
  {
    value: "Papua New Guinean",
    label: "Papua New Guinean 巴布亞新幾內亞籍",
  },
  {
    value: "Paraguayan",
    label: "Paraguayan 巴拉圭籍",
  },
  {
    value: "Peruvian",
    label: "Peruvian 秘魯籍",
  },
  {
    value: "Polish",
    label: "Polish 波蘭籍 ",
  },
  {
    value: "Portuguese",
    label: "Portuguese 葡萄牙籍 ",
  },
  {
    value: "Qatari",
    label: "Qatari 卡塔爾籍",
  },
  {
    value: "Romanian",
    label: "Romanian 羅馬尼亞籍",
  },
  {
    value: "Russian",
    label: "Russian 俄羅斯籍 ",
  },
  {
    value: "Rwandan",
    label: "Rwandan 盧旺達籍",
  },
  {
    value: "Saint Lucian",
    label: "Saint Lucian 聖盧西亞籍",
  },
  {
    value: "Salvadoran",
    label: "Salvadoran 薩爾瓦多籍",
  },
  {
    value: "Samoan",
    label: "Samoan 薩摩亞籍",
  },
  {
    value: "San Marinese",
    label: "San Marinese 聖馬力諾籍",
  },
  {
    value: "Sao Tomean",
    label: "Sao Tomean 聖多美和普林西比籍",
  },
  {
    value: "Saudi",
    label: "Saudi 沙特阿拉伯籍",
  },
  {
    value: "Senegalese",
    label: "Senegalese 塞內加爾籍",
  },
  {
    value: "Serbian",
    label: "Serbian 塞爾維亞籍",
  },
  {
    value: "Seychellois",
    label: "Seychellois 塞舌爾籍",
  },
  {
    value: "Sierra Leonean",
    label: "Sierra Leonean 塞拉利昂籍",
  },
  {
    value: "Singaporean",
    label: "Singaporean 新加坡籍 ",
  },
  {
    value: "Slovak",
    label: "Slovak 斯洛伐克籍",
  },
  {
    value: "Slovenian",
    label: "Slovenian 斯洛文尼亞籍",
  },
  {
    value: "Solomon Islander",
    label: "Solomon Islander 所羅門群島籍",
  },
  {
    value: "Somali",
    label: "Somali 索馬里籍",
  },
  {
    value: "South African",
    label: "South African 南非籍 ",
  },
  {
    value: "South Korean",
    label: "South Korean 南韓籍 ",
  },
  {
    value: "South Sudanese",
    label: "South Sudanese 南蘇丹籍",
  },
  {
    value: "Spanish",
    label: "Spanish 西班牙籍 ",
  },
  {
    value: "Sri Lankan",
    label: "Sri Lankan 斯里蘭卡籍",
  },
  {
    value: "Sudanese",
    label: "Sudanese 蘇丹籍",
  },
  {
    value: "Surinamese",
    label: "Surinamese 蘇里南籍",
  },
  {
    value: "Swazi",
    label: "Swazi 斯威士蘭籍",
  },
  {
    value: "Swedish",
    label: "Swedish 瑞典籍 ",
  },
  {
    value: "Swiss",
    label: "Swiss 瑞士籍 ",
  },
  {
    value: "Syrian",
    label: "Syrian 敘利亞籍",
  },
  {
    value: "Taiwanese",
    label: "Taiwanese 台灣籍 ",
  },
  {
    value: "Tajik",
    label: "Tajik 塔吉克籍",
  },
  {
    value: "Tanzanian",
    label: "Tanzanian 坦桑尼亞籍",
  },
  {
    value: "Thai",
    label: "Thai 泰國籍 ",
  },
  {
    value: "Togolese",
    label: "Togolese 多哥籍",
  },
  {
    value: "Tongan",
    label: "Tongan 湯加籍",
  },
  {
    value: "Trinidadian",
    label: "Trinidadian 特立尼達和多巴哥籍",
  },
  {
    value: "Tunisian",
    label: "Tunisian 突尼斯籍",
  },
  {
    value: "Turkish",
    label: "Turkish 土耳其籍 ",
  },
  {
    value: "Turkmen",
    label: "Turkmen 土庫曼籍",
  },
  {
    value: "Tuvaluan",
    label: "Tuvaluan 圖瓦盧籍",
  },
  {
    value: "Ugandan",
    label: "Ugandan 烏干達籍",
  },
  {
    value: "Ukrainian",
    label: "Ukrainian 烏克蘭籍",
  },
  {
    value: "Uruguayan",
    label: "Uruguayan 烏拉圭籍",
  },
  {
    value: "US",
    label: "United States 美國籍 ",
  },
  {
    value: "Uzbekistani",
    label: "Uzbekistani 烏茲別克籍",
  },
  {
    value: "Vanuatuan",
    label: "Vanuatuan 瓦努阿圖籍",
  },
  {
    value: "Vatican",
    label: "Vatican 梵蒂岡籍",
  },
  {
    value: "Venezuelan",
    label: "Venezuelan 委內瑞拉籍",
  },
  {
    value: "Vietnamese",
    label: "Vietnamese 越南籍 ",
  },
  {
    value: "Yemeni",
    label: "Yemeni 也門籍",
  },
  {
    value: "Zambian",
    label: "Zambian 贊比亞籍",
  },
  {
    value: "Zimbabwean",
    label: "Zimbabwean 津巴布韋籍",
  },
  {
    value: "Other",
    label: "Other 其他籍 ",
  },
];

export const DATA_MAIL_TYPE = [
  { value: "Email", lable: "Email" },
  { value: "Post", lable: "Post" },
  { value: "Email & Post", lable: "Email & Post" },
  { value: "None", lable: "None" },
];

export const DATA_MARKETING_PREFERENCE = [
  { value: "Email", label: "Email 電郵" },
  { value: "Post", label: "Post 郵寄" },
  { value: "Email & Post", label: "Email & Post 電郵及郵寄" },
  { value: "Phone", label: "Phone 電話" },
  { value: "None", label: "None 不接收" },
];

export const DATA_EDUCATION_LEVEL = [
  {
    value: "Primary level or below",
    label: "Primary level or below 小學或以下 ",
  },
  {
    value: "Secondary",
    label: "Secondary 中學 ",
  },
  {
    value: "Non-Degree Tertiary",
    label: "Non-Degree Tertiary 非學位專上 ",
  },
  {
    value: "University or above",
    label: "University or above 大學或以上 ",
  },
];

export const DATA_TICKET_ASSIGN_METHODS = [
  { value: "ALL", label: "All Memebers" },
  { value: "Random Member", label: "Random member" },
  { value: "Lesser Case", label: "Less Case Member" },
];

export const DATA_REPORT_PRODUCT_TYPE = [
  { value: "original", label: "Provider" },
  // { value: "9550", label: "95% / 50%" },
];
export const DATA_QUO_REQUEST_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "CAN", label: "Cancelled" },
  { value: "DONE", label: "Quotation Done" },
  { value: "CONFIRM", label: "Confirmed by Client" },
  { value: "COPIEDDN", label: "Debit Note Done" },
];

export const DATA_CN_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "RCV", label: "Broker Received" },
  { value: "SETTLED", label: "Settled" },
  { value: "CAN", label: "Cancelled" },
  { value: "WAIT", label: "Waiting Settle" },
  { value: "DELIVERED", label: "Delivered" },
];

export const DATA_DN_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "WAIT", label: "Waiting Confirm Policy" },
  { value: "CAN", label: "Cancelled" },
  { value: "HOLD", label: "Hold Cover" },
  { value: "CONFIRMED", label: "Policy Confirmed" },
  { value: "SETTLED", label: "Settled" }, // will remove
  { value: "EXP", label: "Expired" },
];

export const DATA_DN_PAYMENT_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "WAIT", label: "Waiting Payment" },
  { value: "MATCHING", label: "Matching Payment" },
  { value: "DIRECT", label: "Direct to Provider" },
  { value: "PARTIAL", label: "Partial Payment" },
  { value: "PAID", label: "Paid" },
  { value: "SETTLED", label: "Settled" },
  { value: "EN_NO_PAYMENT", label: "No Payment" },
];

export const DATA_QUO_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "WAIT", label: "Waiting Confirm" },
  { value: "CAN", label: "Cancelled" },
  { value: "CONFIRM", label: "Confirmed" },
];

export const DATA_ORDER_SERVICE_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "RCV", label: "Broker Received" },
  { value: "SUB", label: "Submitted to provider" },
  { value: "CAN", label: "Cancelled" },
  { value: "REJ", label: "Rejected" },
  { value: "COMPLETED", label: "Completed" },
];

export const DATA_ORDER_STATUS = [
  { value: "DFT", label: "Draft" },
  { value: "CAN", label: "Cancelled" },
  { value: "RCV", label: "Received from consultant" },
  { value: "SUB", label: "Submitted to provider" },
  { value: "PND", label: "In Pending" },
  { value: "AIP", label: "Application in Progress (received by insurer)" },
  { value: "AIP_EXP", label: "AIP Expired" },
  { value: "ACT", label: "ACT" },

  { value: "INF", label: "Inforced" },
  { value: "UNKNOWN", label: "Unknown" },

  { value: "SUS", label: "Payment Suspended" },
  { value: "SUR", label: "Surrender" },
  { value: "LAP", label: "Lapsed" },
  { value: "COL", label: "Cool Off" },
  { value: "REJ", label: "Rejected By Provider" },
  { value: "WTH", label: "Withdraw Application" },
  { value: "TRO", label: "Transfered out" },
  { value: "TER", label: "Terminated" },
  { value: "EXP", label: "Expired" },
  { value: "MAT", label: "Matured" },
  { value: "DEA", label: "Deceased" },

  { value: "OTH", label: "Other" },
];

export const formatOrderStatusLabel = (code) => {
  const item = DATA_ORDER_STATUS.find((status) => status.value === code);
  return item ? `[${item.value}] ${item.label}` : code;
};

export const DATA_ORDER_STATUS_OPTIONS = DATA_ORDER_STATUS.map((item) => ({
  value: item.value,
  label: formatOrderStatusLabel(item.value),
})).sort((a, b) => a.label.localeCompare(b.label));

export const DATA_TERMINATION_TYPE = [
  { value: "SUR", label: "Surrender" },
  { value: "LAP", label: "Lapsed" },
  { value: "COL", label: "Cool Off" },
  { value: "REJ", label: "Rejected By Provider" },
  { value: "WTH", label: "Withdraw Application" },
  { value: "TRO", label: "Transfer Out" },
  { value: "CAN", label: "Cancelled" },
];

export const DATA_POLICY_DELIVER_METHODS = [
  { value: "Electronic", label: "Electronic" },
  { value: "By Provider", label: "By Provider" },
  { value: "By Company", label: "By Company" },
];

export const DATA_ORDER_TYPE = [
  { label: "New Biz", value: "NEW" },
  { label: "Transfer In", value: "TRANSFER" },
];

export const DATA_MPF_ACCOUNT_TYPE = [
  { value: "Employer Compulsory", label: "Employer Compulsory" },
  { value: "Employer Voluntary", label: "Employer Voluntary" },
  { value: "Employee Compulsory", label: "Employee Compulsory" },
  { value: "Employee Voluntary", label: "Employee Voluntary" },
  { value: "Personal", label: "Personal" },
  { value: "Self-Employed", label: "Self-Employed" },
];

export const getMpfAccountTypeOptions = (t) =>
  DATA_MPF_ACCOUNT_TYPE.map(({ value, label }) => ({
    value,
    label: t(label),
  }));

export const DATA_ORDER_APPLICATION_METHOD = [
  { value: "Paper", label: "Paper Application 紙本申請" },
  { value: "E", label: "E Application 電子申請" },
];

export const DATA_ORDER_POLICY_DOCUMENT_TYPE = [
  { value: "Paper", label: "Paper Policy 紙本保單" },
  { value: "E", label: "E Policy 電子保單" },
];

export const DATA_AR_SUBMISSION_VIA = [
  { value: "Paper", label: "Paper 書面" },
  { value: "Online", label: "Online 網上" },
];

export const DATA_AR_TRANSACTION_TYPE = [
  { value: "Subscription", label: "Subscription 認購" },
  { value: "RSP", label: "RSP 定期投資計劃" },
  { value: "Switching", label: "Switching 轉換" },
];

export const DATA_AR_INVESTMENT_OBJECTIVE = [
  { value: "Safety", label: "Safety / Risk Diversification 財務保障 / 分散風險" },
  { value: "CapitalGrowth", label: "Capital Growth 財富增值" },
  { value: "Income", label: "Income 主要收入" },
  { value: "Other", label: "Others 其他" },
];

export const DATA_AR_INVESTMENT_HORIZON = [
  { value: "LessThan1Year", label: "Less Than 1 Year 少於 1 年" },
  { value: "1To3Years", label: "1 year to less than 3 years 1 年至少於 3 年" },
  { value: "3To5Years", label: "3 years to less than 5 years 3 年至少於 5 年" },
  { value: "5To10Years", label: "5 years to less than 10 years 5 年至少於 10 年" },
  { value: "MoreThan10Years", label: "More than 10 years 超過 10 年" },
];

export const DATA_AR_COMMISSION_ACCOUNT_TYPE = [
  { value: "Wrap", label: "Wrap Account 包管賬戶" },
  { value: "NonWrap", label: "Non-Wrap Account 非包管賬戶" },
];

export const DATA_PAYMENT_METHOD = [
  { value: "DDA", label: "AutoPay DDA 自動過數" },
  { value: "Bank Transfer", label: "Bank Transfer 銀行過戶" },
  { value: "Cash", label: "Cash 現金" },
  { value: "Cheque", label: "Cheque 支票" },
  { value: "Credit Card", label: "Credit Card 信用咭" },
  { value: "FPS", label: "FPS" },
  { value: "Online Banking", label: "Online Banking 網上銀行" },
  { value: "No Payment", label: "No Payment 沒付款" },
  { value: "Others", label: "Others 其他" },
];

export const DATA_CLIENT_PAYMENT_METHOD = [
  { value: "Bank Transfer", label: "Bank Transfer 銀行過戶" },
  { value: "Cash", label: "Cash 現金" },
  { value: "Cheque", label: "Cheque 支票" },
  { value: "CLIENT_CREDIT", label: "Client Credit 客戶信用" },
  { value: "Credit Card", label: "Credit Card 信用咭" },
  { value: "FPS", label: "FPS" },
  { value: "Online Banking", label: "Online Banking 網上銀行" },
];

export const DATA_CONSULTANT_PAYMENT_METHOD = [
  { value: "Bank Transfer", label: "Bank Transfer" },
  { value: "Cash", label: "Cash" },
  { value: "Cheque", label: "Cheque" },
  { value: "FPS", label: "FPS" },
];

export const DATA_PERSONAL_TRADING_BROKERS = [
  {
    value: "Bank of China (Hong Kong)",
    label: "Bank of China (Hong Kong) 中國銀行(香港)",
  },
  { value: "BOCI", label: "BOCI 中銀國際" },
  {
    value: "Bright Smart Securities",
    label: "Bright Smart Securities 耀才證券",
  },
  {
    value: "China Merchants Securities",
    label: "China Merchants Securities 招商證券",
  },
  { value: "Citigroup", label: "Citigroup 花旗" },
  { value: "CITIC Securities", label: "CITIC Securities 中信證券" },
  {
    value: "Core Pacific-Yamaichi",
    label: "Core Pacific-Yamaichi 京華山一",
  },
  { value: "Futu Securities", label: "Futu Securities 富途證券" },
  { value: "Goldman Sachs", label: "Goldman Sachs 高盛" },
  { value: "Guotai Junan", label: "Guotai Junan 國泰君安" },
  { value: "Haitong International", label: "Haitong International 海通國際" },
  { value: "HSBC", label: "HSBC 滙豐" },
  {
    value: "Interactive Brokers",
    label: "Interactive Brokers 盈透證券",
  },
  { value: "JP Morgan", label: "JP Morgan 摩根大通" },
  { value: "Macquarie", label: "Macquarie 麥格理" },
  { value: "Morgan Stanley", label: "Morgan Stanley 摩根士丹利" },
  { value: "Phillip Securities", label: "Phillip Securities 輝立證券" },
  { value: "Standard Chartered", label: "Standard Chartered 渣打" },
  { value: "Tiger Brokers", label: "Tiger Brokers 老虎證券" },
  { value: "UBS", label: "UBS 瑞銀" },
];

export const DATA_PERSONAL_TRADING_ACCOUNT_TYPE = [
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "JOINT", label: "Joint" },
  { value: "CORPORATE", label: "Corporate" },
  { value: "MARGIN", label: "Margin" },
  { value: "OTHER", label: "Other" },
];

export const DATA_PERSONAL_TRADING_RELATIONSHIP = [
  { value: "SELF", label: "Self" },
  { value: "SPOUSE", label: "Spouse" },
  { value: "CHILD", label: "Child" },
  { value: "PARENT", label: "Parent" },
  { value: "OTHER", label: "Other" },
];

export const DATA_PERSONAL_TRADING_STATUS = [
  { value: "ACTIVE", label: "Active" },
  { value: "CLOSED", label: "Closed" },
];

export const DATA_PERSONAL_TRADING_MARKET = [
  { value: "HK", label: "Hong Kong" },
  { value: "US", label: "United States" },
  { value: "CN", label: "China" },
  { value: "OTHER", label: "Other" },
];

export const DATA_PERSONAL_TRADING_PRODUCT_TYPE = [
  { value: "EQUITY", label: "Equity" },
  { value: "BOND", label: "Bond" },
  { value: "FUND", label: "Fund" },
  { value: "DERIVATIVES", label: "Derivatives" },
  { value: "OTHER", label: "Other" },
];

export const DATA_PERSONAL_TRADING_CURRENCY = [
  { value: "HKD", label: "HKD" },
  { value: "USD", label: "USD" },
  { value: "CNY", label: "CNY" },
  { value: "OTHER", label: "Other" },
];

export const DATA_BANK = [
  { value: "003", label: "Standard Chartered Hong Kong 渣打銀行(香港)" },
  {
    value: "004",
    label: "Hongkong and Shanghai Banking Corporation 香港上海滙豐銀行",
  },
  {
    value: "009",
    label: "China Construction Bank (Asia) 中國建設銀行(亞洲)",
  },
  { value: "012", label: "Bank of China (Hong Kong) 中國銀行(香港)" },
  { value: "015", label: "Bank of East Asia 東亞銀行" },
  { value: "016", label: "DBS Bank (Hong Kong) 星展銀行(香港)" },
  { value: "018", label: "China CITIC Bank International 中信銀行國際" },
  { value: "020", label: "CMB Wing Lung Bank 招商永隆銀行" },
  { value: "024", label: "Hang Seng Bank 恒生銀行" },
  { value: "025", label: "Shanghai Commercial Bank 上海商業銀行" },
  {
    value: "027",
    label: "Bank of Communications (Hong Kong) 交通銀行(香港)",
  },
  { value: "028", label: "Public Bank (Hong Kong) 大眾銀行(香港)" },
  { value: "035", label: "OCBC Wing Hang Bank 華僑永亨銀行" },
  { value: "038", label: "Tai Yau Bank 大有銀行" },
  { value: "039", label: "Chiyu Banking Corporation 集友銀行" },
  { value: "040", label: "Dah Sing Bank 大新銀行" },
  { value: "041", label: "Chong Hing Bank 創興銀行" },
  { value: "043", label: "Nanyang Commercial Bank 南洋商業銀行" },
  { value: "061", label: "Tai Sang Bank 大生銀行" },
  {
    value: "072",
    label: "Industrial and Commercial Bank of China (Asia) 中國工商銀行(亞洲)",
  },
  { value: "128", label: "Fubon Bank (Hong Kong) 富邦銀行(香港)" },
  { value: "250", label: "Citibank (Hong Kong) Limited" },
  { value: "385", label: "PING AN BANK CO., LTD." },
  { value: "387", label: "ZA BANK LIMITED" },
  { value: "388", label: "LIVI VB LIMITED" },
  { value: "389", label: "MOX BANK LIMITED" },
  { value: "390", label: "WELAB BANK LIMITED" },
  { value: "391", label: "FUSION BANK LIMITED" },
  { value: "392", label: "PING AN ONECONNECT BANK (HONG KONG) LIMITED" },
  { value: "393", label: "ANT BANK (HONG KONG) LIMITED" },
  { value: "395", label: "AIRSTAR BANK LIMITED" },
  { value: "238", label: "China Merchants Bank 招商銀行" },
  {
    value: "239",
    label: "TAIPEI FUBON COMMERCIAL BANK CO., LTD 台北富邦商業銀行",
  },
  {
    value: "206",
    label: "CHANG HWA COMMERCIAL BANK 彰化商業銀行",
  },
  {
    value: "353",
    label: "CHINA MINSHENG BANKING CORP 中國民生銀行",
  },

  {
    value: "236",
    label: "CATHAY UNITED BANK 國泰世華商業銀行",
  },
  {
    value: "CUC",
    label: "The Currency Cloud Limited",
  },
];
